module.exports = __webpack_public_path__ + "media/icons/direction-ltr-041f56d6.svg";